import React, { useState } from 'react';

import { ContentBoxInfo, MessageBox } from 'components';
import { checkMaintenanceBanner } from 'helpers/Utility';
import { Typography, withStyles } from '@material-ui/core';
import styles from './styles';
import DrawerMaintenanceInfo from 'components/DrawerMaintenanceInfo';

const FlagBoxMaintenance = props => {
  const { flagBoxs, appStatus, classes } = props;

  const [openDetail, setOpenDetail] = useState(false);

  const getMessageBox = flagBox => {
    if (!checkMaintenanceBanner(flagBox.activatedOn, appStatus)) return null;

    const hasDetail = flagBox.descriptionFlagBox?.includes('Lihat Detail');
    const desc = flagBox.descriptionFlagBox?.replace('Lihat Detail', '').trim();

    const content = (
      <ContentBoxInfo
        description={
          <>
            <span>{desc}</span>
            {hasDetail && (
              <Typography
                className={classes.title}
                color="secondary"
                onClick={() => {
                  setOpenDetail(true);
                }}
                variant="caption"
              >
                Lihat Detail
              </Typography>
            )}
          </>
        }
        title={flagBox.titleFlagBox}
        type={flagBox.typeFlagBox}
      />
    );

    if (flagBox.typeFlagBox === 'WARNING') {
      return (
        <MessageBox
          BorderOrange
          Orange
          className={classes.messageBoxMaintenance}
        >
          {content}
        </MessageBox>
      );
    }

    return (
      <MessageBox
        Blue
        BorderBrightBlue
        className={classes.messageBoxMaintenance}
      >
        {content}
      </MessageBox>
    );
  };

  return (
    <>
      <DrawerMaintenanceInfo
        setOpenDetail={setOpenDetail}
        openDetail={openDetail}
      />
      {flagBoxs && flagBoxs.map(flagBox => getMessageBox(flagBox))}
    </>
  );
};

export default withStyles(styles)(FlagBoxMaintenance);
